module.exports = __webpack_public_path__ + "media/img/favicon/mstile-144x144-6d1961a6ba0b7b0b1fbf2f17e0e276d7.png";